var StringUtils = {
	resolvePlaceHolder: function resolvePlaceHolder(url, params) {
		var retValue = url + '';
		if (typeof params == 'object' && params != null) {
			for (var placeholder in params) {
				if (params.hasOwnProperty(placeholder)) {
					var regex = new RegExp('\{' + placeholder + '\}', 'g');
					retValue = retValue.replace(regex, params[placeholder]);
				}
			}
		}
		return retValue;
	}
};

export default StringUtils;
